export const myTasksKeys = {
  getMyTasks: ({ companyId }: { companyId: string }) => ['my-tasks', companyId],
};
